__turbopack_context__.v({
  "below": "LCatalogSingleColumnFull-module__zxohNq__below",
  "content": "LCatalogSingleColumnFull-module__zxohNq__content",
  "root": "LCatalogSingleColumnFull-module__zxohNq__root",
});
